import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ThemeModule } from '../@theme/theme.module';
import { NbMenuModule, NbCardModule, NbInputModule, NbButtonModule } from '@nebular/theme';

import { PagesComponent } from './pages.component';
import { OrdersModule } from './orders/orders.module';
import { PagesRoutingModule } from './pages-routing.module';
import { ProductsModule } from './products/products.module';
import { DashboardModule } from './dashboard/dashboard.module';

@NgModule({
  imports: [
    PagesRoutingModule,
    ThemeModule,
    NbMenuModule,
    FormsModule,
    NbInputModule,
    NbButtonModule,
    ProductsModule,
    OrdersModule,
    NbCardModule,
    DashboardModule,
  ],
  declarations: [
    PagesComponent,
  ],
})
export class PagesModule {
}
